// Every number the render depends on, in one file.
//
// GEOMETRY. A real Group 3 fax is 1728 pixels per scanline at 204x98 dpi. That
// is an ANISOTROPIC 2.09:1 — a fax page prints about 6% squatter than A4, and
// that squash is a large part of why a fax reads as a fax rather than as a
// black-and-white photo.
//
// We honour the ratio and fake the resolution, because the binding constraint
// is not fidelity, it is WhatsApp. Whatever we export, a messenger downscales,
// and a downscaled dither turns to grey mud — the dot pattern beats against the
// new pixel grid. 1080 is the width messengers target, so nothing resizes and
// the dither arrives intact. 1080x714 is a fax at 130x62 dpi: the same 2.09:1
// anisotropy as the real thing.
//
// Going to true 1728 later is changing GRID_W and GRID_H and nothing else.

export const GRID_W = 1080;
export const GRID_H = 714;

// Fax machines print by doubling each scanline vertically. So do we — with
// smoothing OFF, or the browser interpolates the dither back into grey.
export const V_SCALE = 2;
export const OUT_W = GRID_W;
export const OUT_H = GRID_H * V_SCALE; // 1428

// Bands, in grid pixels.
export const HEADER_H = 26;
export const FOOTER_H = 22;
// A SAFE MARGIN, BECAUSE MESSENGERS CROP. WhatsApp shows a fax in a bubble
// zoomed a few percent on every side (and a GIF, which it turns into a video,
// a little more), so with 24px of margin the header line, the first letter of
// TO and the start of the memo were all outside the bubble. ~6% sideways and
// ~4% top and bottom keeps every printed word inside whatever crop a chat app
// applies — and a real fax has exactly this band of nothing before the TSI
// line, so it costs the look nothing.
export const MARGIN_X = 64;
export const MARGIN_Y = 30;

// The image area between the two printed bands.
export const HEADER_TOP = MARGIN_Y;
export const CONTENT_TOP = MARGIN_Y + HEADER_H + 10;
export const CONTENT_H = GRID_H - CONTENT_TOP - FOOTER_H - MARGIN_Y - 8;

// COLOURS ARE CONSTANTS, NOT TOKENS. The exported image must never read a CSS
// variable: it is a file that outlives the stylesheet, and it has to look the
// same in dark mode, in another app's viewer, and in three years.
export const PAPER = '#f7f5f0';   // warm, never #ffffff — a pure white page reads as a PNG, not paper
export const INK = '#101010';

// After the final threshold every pixel is exactly one of these two.
export const PURE_WHITE = 255;
export const PURE_BLACK = 0;

/** The one threshold, used by every stage that has to make a hard decision. */
export const MID = 128;

export const CONDITIONS = ['mint', 'used', 'haunted'];

/**
 * How wrecked, 0..1, per condition.
 *
 * MINT IS A LEGIBILITY FLOOR, not merely "less". At mint there is no skew, no
 * dropped scanlines and no streaks at all — it is the escape hatch for someone
 * who cannot read the fax, and for a low-vision user it is the difference
 * between a usable app and an unusable one.
 */
export const WRECK = { mint: 0, used: 0.45, haunted: 1 };
